import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  Button,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const CourseModules = () => {
  const [expanded, setExpanded] = useState({});

  const handleToggle = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const moduloData = [
    {
      title: "FÍSICA",
      listItems: [
        "1.- BIENVENIDA",
        "2.- HISTORIA DE IMAGENOLOGÍA",
        "3.- TÉCNICAS GENERALES DE RASTREO",
        "4.- FÍSICA DEL ULTRASONIDO I",
        "5.- BOTONOLOGÍA I ",
        " ",
        "1.- FISICA DE ULTRASONIDO II Y III",
        "2.- ARMONICAS Y ECORREALZADORES",
        "3.- BOTONOLOGÍA II",
        " ",
        "1.- FISICA DE DOPPLER.",
        "2.- TECNICAS DEL RASTREO DOPPLER.",
        "3.- VALOR GENERAL DE LOS ÍNDICES DOPPLER."
      ]
    },
    {
      title: "GINECOLOGÍA",
      listItems: [
        "1.- TECNICAS DE RASTREO ABDOMEN INFERIOR.",
        "2.- UTERO, NORMAL Y MALFORMACIONES CONGENITAS.",
        "3.- UTERO, TUMORACIONES.",
        "4.- ENDOMETRIO EN LA EDAD Y CICLO.",
        " ",
        "1.- PATOLOGIAS DEL ENDOMETRIO, ENDOMETRIOSIS Y ADENOMIOSIS.",
        "2.- CANCER DEL ENDOMETRIO.",
        "3.- INCOMPETENCIA DEL PISO PERINEAL.",
        "4.- ENFERMEDAD PELVICA INFLAMATORIA.",
        " ",
        "1.- OVARIO NORMAL Y CICLO TRANS. DISFUNCIONAL  DE LUF.",
        "2.- TUMORES BENIGNOS Y MALIGNOS DE OVARIO.",
        "3.- SINDROME DE OVARIOS POLIQUISTICOS.",
        " ",
        "1.- MAMAS ASPECTOS GENER. Y FUNCLS NORMAL. EN REL. A EDAD.",
        "2.- MAMAS ESTUDIO RADIOGRAFICO.",
        "3.- MAMAS ESTUDIO POR ULTRASONIDO."
      ]
    },
    {
      title: "OBSTETRICIA",
      listItems: [
        "1.- INTRODUCCION AL AREA DE OBSTETRICIA.",
        "2.- ANATOMIA Y FISIOLOGIA DE LA IMPLANTANCIA.",
        "3.- EMBRIOLOGIA Y DESARROLLO PRIMER TRIMESTRE.",
        "4.- SACO GESTACIONAL, VITALIDAD, PLIEGUE NUCAL.",
        " ",
        "1.- DESARROLLO FETAL NORMAL.",
        "2.- FETOMETRIA.",
        "3.- PLACENTA, CORDON UMBILICAL, LIQUIDO AMNIOTICO.",
        "4.- CORAZON FETAL, PARAMETROS NORMALES.",
        " ",
        "1.- PATOLOGIA DEL PRIMER TRIMESTRES.",
        "2.- DEFECTOS DEL TORAX FETAL.",
        "3.- DEFECTOS DEL SISTEMA NERVIOSO CENTRAL.",
        " ",
        "1.- EMBARAZO MULTIPLE.",
        "2.- MUERTE FETAL.",
        "3.- EL REPORTE.",
        " ",
        "1.- DEFECTOS DE ABDOMEN Y TRACTO URINARIO.",
        "2.- HIDROPS. FETALIS.",
        "3.- HALLAZGOS ECOGRAFICOS DE ANORMALIDADES CROMOSOMICAS."
      ]
    },
    {
      title: "ABDOMEN SUPERIOR",
      listItems: [
        "1.- RASTEO DEL ABDOMEN SUPERIOR.",
        "2.- ANATOMIA HEPÁTICA NORMAL Y AL ULTRASONIDO.",
        "3.- LESIONES HEPÁTICAS DIFUSAS Y FOCALIZADAS.",
        " ",
        "1.- ANATOMIA NORMAL DE VESICULA Y VIAS BILIARES.",
        "2.- PATOLOGIA DE VESICULA BILIAR.",
        "3.- PANCREAS Y BAZO NORMAL Y PATOLOGICO.",
        "4.- RECESOS Y RETROPERITONEO."
      ]
    },
    {
      title: "APARATO GENITO-URINARIO",
      listItems: [
        "1.- RIÑONES, GENETICA, ANATOMIA NORMAL Y MALFORMACIONES.",
        "2.- PROCESOS INFECCIOSOS Y OBSTRUCTIVOS TRACTO URINARIO.",
        "3.- TUMORES RENALES.",
        "4.- TRANSTORNOS DISFUNCIONALES RENALES.",
        " ",
        "1.- DOPPLER RENAL.",
        "2.- PROSTATA, ASPECTO NORMAL Y PATOLOGIAS.",
        "3.- DOPPLER PROSTATICO Y DOPPLER EN OBSTRUCCION RENO-URETERAL, AGUDA Y CRÓNICA.",
        " ",
        "1.- PENE, ANATOMIA Y FISIOLOGIA NORMAL.",
        "2.- ENF. DE PEYRONIE",
        "3.- U.S. PENEANO, DISFUNCION ERECTIL.",
        "4.- ESCROTO Y CONTENIDO NORMAL.",
        "5.- PATOLOGIAS TESTICULARES.",
        " ",
        "1.- ANATOMIA DEL PERITONEO.",
        "2.- ABDOMEN, TRACTO G.I. OBSTRUC. INTESTINAL ABDOMEN AGUDO.",
        "3.- APENDICITIS AGUDA, ABSCESO PELVICO.",
      ]
    }
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#fffff',
        borderRadius: '10px',
        padding: '20px',
        mx: { xs: 0, sm: '30px' },
      }}
    >
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 'bold',
          mb: 4,
          color: '#495057',
        }}
      >
        Módulos del Diplomado
      </Typography>
      <Grid container spacing={5}>
        {moduloData.map((modulo, index) => {
          const isExpanded = expanded[index];

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  background: '#fffff',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  boxShadow: '0px 15px 15px rgba(0, 0, 0, 0.15)',
                  transform: isExpanded ? 'scale(1.03)' : 'scale(1)',
                  opacity: isExpanded ? 1 : 0.95,
                  transition:
                    'transform 0.5s ease, box-shadow 0.5s ease, opacity 0.5s ease',
                  '&:hover': {
                    boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.2)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <CardContent
                  sx={{
                    padding: '20px',
                    textAlign: 'center',
                    position: 'relative',
                    transition: 'opacity 0.4s ease, transform 0.4s ease',
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      color: '#343a40',
                      mb: 2,
                      borderBottom: '2px solid #e9ecef',
                      pb: 1,
                    }}
                  >
                    {modulo.title}
                  </Typography>
                  <List
                    sx={{
                      maxHeight: isExpanded ? '300px' : '150px', // Altura máxima: expandida o colapsada
                      overflow: 'hidden', // Ocultar contenido fuera del contenedor
                      transition: 'max-height 0.5s ease, opacity 0.5s ease',
                      opacity: 1, // Mantener opacidad visible siempre
                      position: 'relative',
                      '&::after': {
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        background: 'linear-gradient(to top, #ffffff, transparent)',
                        height: '20px',
                        width: '100%',
                        display: isExpanded ? 'none' : 'block',
                        textAlign: 'center',
                      },
                    }}
                  >
                    {modulo.listItems.map((item, i) => (
                      <ListItem key={i} sx={{ padding: '5px 0' }}>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
                <Button
                  fullWidth
                  onClick={() => handleToggle(index)}
                  sx={{
                    padding: '10px 0',
                    backgroundColor: '#f8f9fa',
                    color: '#495057',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    borderRadius: '0',
                    borderTop: '1px solid #dee2e6',
                    transition: 'background-color 0.3s ease, color 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#e9ecef',
                      color: '#212529',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {isExpanded ? (
                    <>
                      <ExpandLess sx={{ mr: 1 }} />
                      Colapsar
                    </>
                  ) : (
                    <>
                      <ExpandMore sx={{ mr: 1 }} />
                      Expandir
                    </>
                  )}
                </Button>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CourseModules;
